<div class="foto">
  <img [src]="imgSource" class="img-fluid" [alt]="imgAlt" *ngIf="imgSource">
  <img src="assets/img/profile.svg" [alt]="imgAlt" *ngIf="!imgSource">
</div>

<small class="text-gray" *ngIf="infoText">{{infoText}}</small>
<div class="d-flex align-items-center mt-2">
  <button
    *ngIf="!hasImage"
    type="submit"
    class="btn btn-sm rounded-pill btn-primary col"
    (click)="inputPhoto.click()"
  >
    {{submitText}}
  </button>
  <button
    class="btn btn-sm rounded-pill btn-primary col"
    *ngIf="hasImage"
    (click)="clear()"
  >
    Remover foto
  </button>
</div>

<input type="file" name="inputPhoto" [accept]="accept" #inputPhoto class="d-none" (change)="onSelectFile($event)">
